import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Find Us</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans">Lane Ends Bungalow, Whatcroft Hall Lane, Rudheath, Detroit, MI</p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Opening Hours</p>
        <p className="p__opensans">Mon - Fri: 10:00 aM - 02:00 aM</p>
        <p className="p__opensans">Sat - Sun: 10:00 aM - 03:00 aM</p>
      </div>
      <button type="button" className="custom__button" style={{ marginTop: '2rem' }}><a href="https://goo.gl/maps/PJfKMrJW69JG2doa7" rel="noreferrer" target="_blank">Visit us</a></button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.findus} alt="finus_img" />
    </div>
  </div>
);

export default FindUs;
